import {token} from "@atlaskit/tokens";

export function AnankeTempDisabledInlineEditableTextField({value}: {value: string}) {
    return (
        <div
            className="w-full"
            style={{
                border: `${token("border.width.selected")} solid transparent`,
            }}
        >
            {/* text-ds-font-body */}
            <div className="w-full px-ds-space-075 py-ds-space-100">{value}</div>
        </div>
    );
}
